<template>
  <div class="ma-4">
    <ClientNav :clientState="clientState" />

    <div class="grey lighten-5">
      <v-row dense>
        <v-progress-linear
          v-model="value"
          :active="show"
          :indeterminate="query"
          :query="true"
          color="cyan"
        ></v-progress-linear>
        <v-col cols="12" lg="3" xl="2" md="3">
          <ClientSide />
        </v-col>
        <v-col cols="12" lg="6" xl="7" md="9">
          <v-card class="pa-2" outlined tile>
            <v-row>
              <v-col cols="12" md="12">
                <div>
                  <h2>Client Bio</h2>
                  <v-divider></v-divider>
                  <v-card
                    elevation="0"
                    class="overflow-y-auto"
                    tile
                    min-height="100"
                  >
                    <div class="pa-2 text-md-subtitle-2">
                      {{ client.Bio }}
                    </div>
                  </v-card>
                </div>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" md="6" sm="12">
                <v-card elevation="0" outlined>
                  <v-card-title class="mx-2 mt-1 mb-1"
                    >MAR
                    <v-btn
                      :to="'/mar/' + clientID + '/mar'"
                      absolute
                      right
                      small
                      class="mt-n1 cyan darken-3 white--text"
                      >View MAR</v-btn
                    >
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-row>
                    <v-col class="ml-1 mb-0 pb-0 pr-5 mt-1" cols="12">
                      <v-select
                        :items="sortOption"
                        v-model="selectedSortOption"
                        @change="sortItem()"
                        label="SORT BY"
                        solo
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-virtual-scroll
                    :items="sortedItem.mar"
                    :item-height="80"
                    height="550"
                  >
                    <template v-slot:default="{ item }">
                      <v-list>
                        <v-divider class="mx-5" :key="item._id"></v-divider>
                        <v-list-item class="my-3 ml-5 project">
                          <v-list-item-content class="ml-n2">
                            <v-list-item-title
                              class="text-md-subtitle-2"
                              v-html="item.Medication"
                            ></v-list-item-title>
                            <v-list-item-title class="text-md-subtitle-2">
                              {{ item.AdminTime }}
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-icon>
                            <div class="mr-3">
                              <v-chip
                                class="ma-2 list-btn-size"
                                small
                                :color="item.status.color"
                                text-color="white"
                              >
                              {{ item.status.text}}
                              </v-chip>
                            </div>
                          </v-list-item-icon>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-virtual-scroll>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-card elevation="0" outlined>
                  <v-card-title class="mx-2 mt-1 mb-1"
                    >ADL
                    <v-btn
                      :to="'/adl/' + clientID"
                      absolute
                      right
                      small
                      class="mt-n1 cyan darken-3 white--text"
                      >View ADL</v-btn
                    >
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-virtual-scroll
                    :items="sortedItem.adl"
                    :item-height="80"
                    height="550"
                  >
                    <template v-slot:default="{ item }">
                      <v-list>
                        <v-divider class="mx-5" :key="item._id"></v-divider>
                        <v-list-item class="my-3 ml-5 project">
                          <v-list-item-content class="ml-n2">
                            <v-list-item-title
                              class="text-md-subtitle-2"
                              v-html="item.ServiceItem"
                            ></v-list-item-title>
                            <v-list-item-title class="text-md-subtitle-2">
                              {{ item.ScheduledTime }}
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-icon>
                            <div class="mr-3">
                              <v-chip
                                class="ma-2 list-btn-size"
                                small
                                :color="item.Signed ? 'green' : 'red'"
                                text-color="white"
                              >
                                {{ item.Signed ? "Completed" : "Incomplete" }}
                              </v-chip>
                            </div>
                          </v-list-item-icon>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-virtual-scroll>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" lg="3" md="12">
          <v-card
            class="overflow-y-auto"
            max-height="250"
            outlined
            tile
            min-height="25%"
            scrollable
          >
            <v-col cols="12">
              <div class="font-weight-light text-center">
                <v-icon class="red--text">person</v-icon>
                Client Allergies
              </div>
              <v-list>
                <v-divider></v-divider>
                <v-list-item-group>
                  <v-list-item
                  v-for="(allergy, index) in client.Allergies"
                    :key="index"
                    class="red lighten-4"
                  >
                    <!-- <v-list-item-avatar size="30">
                    <v-icon
                      small
                      :class="[update.iconClass]"
                      v-text="update.icon"
                    ></v-icon>
                  </v-list-item-avatar> -->

                    <v-list-item-content
                      class="text-md-subtitle-2"
                      v-text="allergy.Allergy"
                    >
                      <!-- <v-list-item-title
                      v-text="warn.Description"
                    ></v-list-item-title> -->
                      <!-- <v-list-item-subtitle
                      v-text="warn.Date"
                    ></v-list-item-subtitle> -->
                    </v-list-item-content>

                    <!-- <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item-action>
                        <v-btn icon v-on="on" v-bind="attrs">
                          <v-icon color="red lighten-1">mdi-information</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </template>
                    <span class="font-weight-light"
                      >Created by: John Smith <br />
                      24 seconds ago</span
                    >
                  </v-tooltip> -->
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-card>
          <v-card
            class="overflow-y-auto"
            max-height="250"
            outlined
            tile
            min-height="25%"
            scrollable
          >
            <v-col cols="12">
              <div class="font-weight-light text-center">
                <v-icon class="red--text">warning</v-icon>
                Client Warnings
              </div>
              <v-list>
                <v-divider></v-divider>
                <v-list-item-group>
                  <v-list-item
                    v-for="(warn, index) in client.Warnings"
                    :key="index"
                    class="red lighten-4"
                  >
                    <!-- <v-list-item-avatar size="30">
                    <v-icon
                      small
                      :class="[update.iconClass]"
                      v-text="update.icon"
                    ></v-icon>
                  </v-list-item-avatar> -->

                    <v-list-item-content
                      class="text-md-subtitle-2"
                      v-text="warn.Description"
                    >
                      <!-- <v-list-item-title
                      v-text="warn.Description"
                    ></v-list-item-title> -->
                      <!-- <v-list-item-subtitle
                      v-text="warn.Date"
                    ></v-list-item-subtitle> -->
                    </v-list-item-content>

                    <!-- <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item-action>
                        <v-btn icon v-on="on" v-bind="attrs">
                          <v-icon color="red lighten-1">mdi-information</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </template>
                    <span class="font-weight-light"
                      >Created by: John Smith <br />
                      24 seconds ago</span
                    >
                  </v-tooltip> -->
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-card>

          <v-card
            class="overflow-y-auto"
            max-height="500"
            outlined
            tile
            min-height="50%"
          >
            <v-col cols="12">
              <div class="font-weight-light text-center">
                <v-icon class="red--text">accessible</v-icon>
                Adaptive Equipment
              </div>
              <v-list>
                <v-divider></v-divider>
                <v-list-item-group>
                  <v-list-item
                    v-for="(equip, index) in client.Equipment"
                    :key="index"
                    class="red lighten-4"
                  >
                    <v-list-item-content
                      class="text-md-subtitle-2"
                      v-text="equip.Equipment"
                    >
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- <Foot /> -->
  </div>
</template>
<script>
/* eslint-disable */
import axios from "axios";
import ClientNav from "../../components/ClientNav";
import ClientSide from "../../components/ClientSide";
import Foot from "../../components/Footer";
import { mapGetters, mapActions } from "vuex";

const url = require("../../client_config/config").url;

export default {
  components: {
    ClientNav,
    ClientSide,
    Foot,
  },
  data: () => ({
    value: 0,
    query: false,
    show: true,
    interval: 0,
    client: [],
    tempData: [],
    temp: [],
    tempWarning: [],
    attendance: [],
    medications: [],
    warnings: [],
    adls: [],
    allergies: [],
    sortOption: [
      "Medication",
      "Admin Time",
      "Status Completed",
      "Status Incomplete",
    ],
    selectedSortOption: "",
    chgimg: false,
    uploadImg: "",
    profileimg: "",
    //clientID: localStorage.getItem("clientId"),
    clientID: "",
    clientState: "",
    isLoading: true,
    infos: [
      { title: "Edit Client Info", icon: "medicine", route: "/" },
      { title: "ADL Charting", icon: "medicine", route: "/adl" },
    ],
    equipment: "",
    page: 1,
    itemsPerPage: 10,
    updates: [
      // {
      //   icon: "warning",
      //   iconClass: "red darken-4 white--text",
      //   title: "Incident Report",
      //   subtitle: "Jun 20, 2020",
      //   route: "/",
      // },
      // {
      //   icon: "local_hospital",
      //   iconClass: "blue lighten-1 white--text",
      //   title: "AM Med",
      //   subtitle: "Jun 20, 2020",
      //   route: "/",
      // },
      // {
      //   icon: "local_hospital",
      //   iconClass: "blue lighten-1 white--text",
      //   title: "AM Med",
      //   subtitle: "Jun 20, 2020",
      //   route: "/",
      // },
      // {
      //   icon: "assignment",
      //   iconClass: "yellow darken-4 white--text",
      //   title: "Info Updated",
      //   subtitle: "Jun 20, 2020",
      //   route: "/",
      // },
      // {
      //   icon: "assignment",
      //   iconClass: "yellow darken-4 white--text",
      //   title: "Med Hand Off",
      //   subtitle: "Jun 20, 2020",
      //   route: "/",
      // },
      // {
      //   icon: "local_hospital",
      //   iconClass: "blue lighten-1 white--text",
      //   title: "PM Med",
      //   subtitle: "Jun 20, 2020",
      //   route: "/",
      // },
      // {
      //   icon: "local_hospital",
      //   iconClass: "blue lighten-1 white--text",
      //   title: "PM Med",
      //   subtitle: "Jun 20, 2020",
      //   route: "/",
      // },
      // {
      //   icon: "nights_stay",
      //   iconClass: "black lighten-1 white--text",
      //   title: "Night Check",
      //   subtitle: "Jun 20, 2020",
      //   route: "/",
      // },
      // {
      //   icon: "nights_stay",
      //   iconClass: "black lighten-1 white--text",
      //   title: "Night Check",
      //   subtitle: "Jun 20, 2020",
      //   route: "/",
      // },
      // {
      //   icon: "local_hospital",
      //   iconClass: "blue lighten-1 white--text",
      //   title: "PRN",
      //   subtitle: "Jun 20, 2020",
      //   route: "/",
      // },
      // {
      //   icon: "local_hospital",
      //   iconClass: "blue lighten-1 white--text",
      //   title: "PRN",
      //   subtitle: "Jun 20, 2020",
      //   route: "/",
      // },
      // {
      //   icon: "local_hospital",
      //   iconClass: "blue lighten-1 white--text",
      //   title: "PRN",
      //   subtitle: "Jun 20, 2020",
      //   route: "/",
      // },
    ],
  }),
  mounted() {
    this.queryAndIndeterminate();
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  created() {
    this.clientID = this.$route.params.clientID;
    // this.getClient(this.$route.params.clientID);
    // this.getAttendance();
    this.getClient()
    this.fetchAllClientMedications(this.$route.params.clientID);
    this.fetchAllClientServices(this.$route.params.clientID);
  },

  computed: {
    ...mapGetters({
      adl: "services/getAllClientServices",
      mar: "medications/getAllClientMedications",
    }),

    sortedItem() {
      let mar = this.mar.filter((item) => item != undefined).map(item => {
        let status;
        if (item.Signed && item.Verified) {
          status = {
            color: "green",
            text: "Completed",
          };
        }
        
        if (item.Signed && !item.Verified) {
          status = {
            color: "warning",
            text: "Verifying",
          };
        }
        
        if(!item.Signed && !item.Verified){
          status = {
            color: "red",
            text: "Incomplete",
          };
        }
        return {
          ...item,
          status,
        };
      })

      return {
        mar: this.sortItem(mar.filter((item) => item != undefined)),
        adl: this.sortItem(this.adl),
      };
    },
  },

  methods: {
    queryAndIndeterminate() {
      this.query = true;
      this.value = 0;

      setTimeout(() => {
        this.query = false;

        this.interval = setInterval(() => {
          if (this.value === 100) {
            clearInterval(this.interval);
            this.show = false;
            return setTimeout(this.queryAndIndeterminate, 1000);
          }
          this.value += 25;
        }, 1000);
      }, 2000);
    },
    ...mapActions({
      fetchAllClientServices: "services/fetchAllClientServices",
      fetchAllClientMedications: "medications/fetchAllClientMedications",
      getClientInfo: "clients/getClient",
    }),

    getAttendance() {
      axios.get(`${url}/attendance/client/${this.clientID}`).then((res) => {
        this.attendance = res.data.attendances;
      });
    },

    async getClient() {
      const response = await this.getClientInfo(this.clientID);
      this.client = response;
    },

    sortItem(items) {
      if (this.selectedSortOption === "Medication") {
        return items.sort((a, b) => (a.newItem < b.newItem ? -1 : 1));
      } else if (this.selectedSortOption === "Status Completed") {
        let complete = items.filter((item) => item.Signed === true);
        let incomplete = items.filter((item) => item.Signed === false);
        return complete.concat(incomplete);
      } else if (this.selectedSortOption === "Status Incomplete") {
        let statusIncomplete = items.filter((item) => item.Signed === false);
        let statusCompleted = items.filter((item) => item.Signed === true);
        return statusIncomplete.concat(statusCompleted);
      }
      return items.sort((a, b) => {
        let c = a.newTime - b.newTime;
        if (c != 0) {
          return c;
        }
        return a.newItem - b.newItem;
      });
    },

  },
};
</script>

<style scoped>
.project {
  border-left: 4px solid #2dce89;
}

@media only screen and (max-width: 1366px) and (min-width: 1264px) {
  .list-btn-size {
    font-size: 9px;
  }
}
</style>
